var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70711 12.7929C10.0976 12.4024 10.7308 12.4024 11.1213 12.7929L12.7071 14.3787C13.0976 14.7692 13.0976 15.4024 12.7071 15.7929C12.3166 16.1834 11.6834 16.1834 11.2929 15.7929L9.70711 14.2071C9.31658 13.8166 9.31658 13.1834 9.70711 12.7929Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1213 8.29292C11.7308 7.9024 11.0976 7.9024 10.7071 8.29292C10.3166 8.68345 10.3166 9.31661 10.7071 9.70714L13.2929 12.2929C13.6834 12.6834 14.3166 12.6834 14.7071 12.2929C15.0976 11.9024 15.0976 11.2692 14.7071 10.8787L12.1213 8.29292Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53166 4.39065C7.97935 3.5115 9.91528 3 12 3C14.0847 3 16.0207 3.5115 17.4683 4.39065C18.8978 5.25871 20 6.59394 20 8.25083C20 9.82778 19.1717 10.8571 18.1874 11.6141V17.0005C18.1874 18.6222 16.9067 20 15.2568 20H8.73947C7.08966 20 5.80895 18.6222 5.80895 17.0005V11.6085C4.75003 10.7656 4 9.61662 4 8.25083C4 6.59394 5.10223 5.25871 6.53166 4.39065ZM7.56979 6.10013C6.4654 6.77079 6 7.56099 6 8.25083C6 8.89884 6.40466 9.62766 7.36498 10.2701L7.80895 10.5671V17.0005C7.80895 17.5844 8.25982 18 8.73947 18H15.2568C15.7365 18 16.1874 17.5844 16.1874 17.0005V10.5686L16.6294 10.2714C17.5773 9.63401 18 9.07154 18 8.25083C18 7.56099 17.5346 6.77079 16.4302 6.10013C15.3441 5.44054 13.78 5 12 5C10.22 5 8.65592 5.44054 7.56979 6.10013Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBread);
export default __webpack_public_path__ + "static/media/icon_bread.c5b51af0522a7691e9b96869505cbf8e.svg";
export { ForwardRef as ReactComponent };